import type { ConfigState, DesignOrientation } from '@renderer/types/configState'

/**
 * Logical design canvas for the current device orientation.
 * Never uses legacy `screenSize` raw values when they mismatch orientation
 * (e.g. portrait 1080×1920 in `screenSize` on a landscape display would letterbox as portrait
 * if `screenSizes.landscape` is not applied).
 */
export function getDesignCanvasSizeForOrientation(
  config: ConfigState | null | undefined,
  orientation: DesignOrientation
): { width: number; height: number } {
  const ss = config?.screenSizes
  const direct = ss?.[orientation]
  if (direct && direct.width > 0 && direct.height > 0) {
    return direct
  }
  const otherKey: DesignOrientation = orientation === 'portrait' ? 'landscape' : 'portrait'
  const other = ss?.[otherKey]
  if (other && other.width > 0 && other.height > 0) {
    const ow = other.width
    const oh = other.height
    return orientation === 'portrait'
      ? { width: Math.min(ow, oh), height: Math.max(ow, oh) }
      : { width: Math.max(ow, oh), height: Math.min(ow, oh) }
  }
  const legacy = config?.screenSize
  if (legacy && legacy.width > 0 && legacy.height > 0) {
    const w = legacy.width
    const h = legacy.height
    if (orientation === 'portrait') {
      return h >= w ? { width: w, height: h } : { width: h, height: w }
    }
    return w >= h ? { width: w, height: h } : { width: h, height: w }
  }
  return orientation === 'portrait'
    ? { width: 1080, height: 1920 }
    : { width: 1920, height: 1080 }
}
